module.exports = __webpack_public_path__ + "media/images/main/main-future-1583eacc7f50e2b34f44638270c0747b.jpg";